import React from 'react';
import _get from 'lodash/get';
import { Sector } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import SectorChip from '@lib/components/SectorChip/SectorChip';
import { SelectPanelOptionRendererProps } from '../types';
import styles from '../SelectPanel.module.scss';

export function SectorOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const sector = (_get(option, 'data') as Sector) ?? {
    name: _get(option, 'label'),
    color: _get(option, 'color'),
  };

  // Returns a Fragment (checkbox + content) so both slot directly into the
  // SelectPanel option button's own grid — wrapping them in a single element
  // collapses the content into the button's min-content column.
  return (
    <>
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.entityOptionChipContent}>
        <SectorChip sector={sector} />
      </span>
    </>
  );
}
